<template>
  <div>
    <div class="mb-2 d-flex justify-space-between">
      <span>
        {{ item.time.start | formatDate }} {{ item.time.start | formatTime }} -
        {{ item.time.end | formatTime }}
      </span>
    </div>

    <div v-for="schedule in teacherSchedules" :key="schedule.id">
      <TeacherScheduleItem
        mode="schedule"
        :schedule="schedule"
        :teacher="getTeacher(schedule)"
        :classrooms="classrooms"
      />
    </div>

    <div class="my-4 text-center">
      <v-btn color="blue darken-1" text @click="$emit('on-close')">
        Close
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TeacherScheduleItem from "@/components/teacher/TeacherScheduleItem.vue";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    teachers: {
      type: Array,
      default: null,
    },
    classrooms: {
      type: Array,
      default: null,
    },
  },
  data: () => ({}),
  components: { TeacherScheduleItem },
  computed: {
    ...mapGetters(["isAppLoading", "globalCenter"]),

    teacherSchedules() {
      if (this.item.details) {
        return this.item.details;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage", "clearMessage"]),
    getTeacher(schedule) {
      const teacherId = schedule.teacherId;
      return this.teachers.find((t) => t.id == teacherId);
    }
  },
};
</script>

<style scoped>
.schedule-container {
  border: 1px solid #ccc;
  margin-bottom: 20px;
  padding: 20px;
}
</style>
